import { useParams, Link } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { api, type Stand } from '../lib/api'

interface Eingangszeile {
  id: string
  art: string
  jahr: number
  monat: number | null
  bezeichnung: string
  dateiname: string
  stand: Stand
  herkunft: string
  eingegangen_am: string
  mandant_id: string
  mandant_name: string
  mandantennummer: number
}

const spalten = { gridTemplateColumns: 'minmax(0, 1.3fr) minmax(0, 1fr) 130px' }

export function EingangSeite() {
  const { werkzeug } = useParams()

  // Der Eingang zeigt ausschliesslich Unbearbeitetes. Was analysiert oder
  // versendet ist, findet man beim Mandanten, nicht hier.
  const { data, isPending, error } = useQuery({
    queryKey: ['dokumente', werkzeug, 'offen'],
    queryFn: () =>
      api.holen<{ dokumente: Eingangszeile[] }>(`/api/dokumente?werkzeug=${werkzeug}&stand=offen`),
  })

  const titel = werkzeug === 'bwa' ? 'BWA' : 'Jahresabschluss'

  return (
    <>
      <div className="liste">
        <div className="listenkopf" style={spalten}>
          <div>Auswertung</div>
          <div>Mandant</div>
          <div>Eingegangen</div>
        </div>

        {isPending && <div className="laedt">Wird geladen …</div>}

        {error && (
          <div className="leer">
            <strong>Die Liste konnte nicht geladen werden.</strong>
            {error instanceof Error ? error.message : ''}
          </div>
        )}

        {data && data.dokumente.length === 0 && (
          <div className="leer">
            <strong>Nichts Offenes.</strong>
            <p>
              Neue {titel} Auswertungen erscheinen hier von selbst, sobald die Verbindung zu DATEV
              steht. Bearbeitetes findest du beim jeweiligen Mandanten.
            </p>
          </div>
        )}

        {data?.dokumente.map((zeile) => (
          <Link
            key={zeile.id}
            to={`/${werkzeug}/mandanten/${zeile.mandant_id}`}
            className="zeile"
            style={spalten}
          >
            <div>
              <div className="sache">{zeile.bezeichnung}</div>
              <div className="nebensache">{zeile.dateiname}</div>
            </div>
            <div>
              <div className="leise">{zeile.mandant_name}</div>
              <div className="nebensache zahl">{zeile.mandantennummer}</div>
            </div>
            <div className="leiser zahl">
              {new Date(zeile.eingegangen_am).toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}
            </div>
          </Link>
        ))}
      </div>
    </>
  )
}
